import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { EASI_DESIGN } from '../../theme/design-tokens';

const d = EASI_DESIGN;

export interface TranscriptSegment {
  speaker: string;
  text: string;
  start_time: number;
  end_time: number;
}

interface TranscriptViewProps {
  segments?: TranscriptSegment[];
}

// Format seconds as HH:MM:SS for transcript timestamps
function formatTime(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const hh = Math.floor(s / 3600);
  const mm = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  return `${hh.toString().padStart(2, '0')}:${mm.toString().padStart(2, '0')}:${ss.toString().padStart(2, '0')}`;
}

export default function TranscriptView({ segments }: TranscriptViewProps) {
  if (!segments || segments.length === 0) return null;
  const uniqueSpeakers = new Set(segments.map(s => s.speaker)).size;
  const showSpeakerLabels = uniqueSpeakers > 1;

  return (
    <Box sx={{ mt: 2 }}>
      <Divider sx={{ mb: 1.5 }} />
      <Typography variant="caption" fontWeight={700} color={d.color.emeraldDark} sx={{ textTransform: 'uppercase', display: 'block', mb: 1 }}>
        Transcript
      </Typography>
      {segments.map((seg, i) => (
        <Typography key={i} variant="body2" color="text.primary" sx={{ mt: 0.5 }}>
          <Box component="span" sx={{ color: 'text.secondary', fontFamily: 'monospace', fontSize: '0.85em', mr: 1 }}>
            [{formatTime(seg.start_time)}]
          </Box>
          {showSpeakerLabels && (
            <Box component="span" sx={{ fontWeight: 700, mr: 0.5 }}>{seg.speaker}:</Box>
          )}
          {seg.text}
        </Typography>
      ))}
    </Box>
  );
}
